export const PROP_API_KEY = "gnCK4NVW226nRcHOcOB5NjkWj9JVSDOm";
export const PROP_AUTH_KEY = "AQEBAYAAOaIiJVLGC7JrO8GEWPUFV5re9pzWDFxyoD7UGYEVlmzQ/Xm4FedJwXcsfv4UwqHeof0lWmvxUORL+ItoCPMw2YOIXdNXuIZ7WQaxMwZ+U833fRBctHhoxaphhVPvs/eNcD27P/8iMfiW+OsQfHaesT+NG+qaMeerEb7XBo8sA0wAABAAynxp+R9+dGbUpZXpI32/zhkAAADte1OJZhtU5EgWo2jHbtUGn5sbV0kfETSF";
//export const PROP_AUTH_KEY = "AQEBAYAAXF9gW0q3Dhs+oLYfpI5eHnEMSuGdkV3f4uM4YNkzNKK4G/UCMAqzX9HLcRamipbKeBPGNSXFTthw7dUA2/V6ri8aFcjI2S88BN3Drs4o/Nb5NhYaY4UmraOeQRzN25IhEZNINXdXGa7H9OgRQSiY+8BywczPEjiFb02/xPe9ElMAABAAmhadg3fOemIaJjXwnT6ZsBUAAAANy4RFls7gBlhyXbDWabvdXSd0zvY=";
export const PROP_CUSTOM_NAME = "";
export const PROP_SEARCH_MODE = 6;
export const PROP_SUBSCRIPTION_ID = "jCDHtG5R43WD7ppi";
export const PROP_COMPANY_ID = 1;
export let SESSION_ID = "";
export const setSessionID = _ID => {
  SESSION_ID = _ID;
};
export let USER_ID = ""; 
export const setUserID = _ID => {
  USER_ID = _ID;
};
export let USER_AUTH_ID = "";
export const setAuthID = _ID => {
  USER_AUTH_ID = _ID;
};
export let IS_MOBILE = false;
export const setMobile = _ID => {
  IS_MOBILE = _ID
};